import { getModuleFederatedName, setupServiceInfo } from '@estee/elc-universal-utils';
import { ServiceManager } from '@estee/elc-service';
import { OLAPIC_WIDGET } from '@estee/elc-service-view-names';
import serviceNames, { ProductUgcService } from '~setup/ProductUgcService';

setupServiceInfo(__serviceInfo__);
const { name, version } = __serviceInfo__;

ProductUgcService.setViews(name, getModuleFederatedName(name), version, [OLAPIC_WIDGET]);

ServiceManager.setServiceStartParams({
    serviceName: name,
    diContainerImport: () => import('~setup/diContainer'),
    serviceKey: serviceNames.productUgcService
});
